import React from "react";
import ReactDOM from "react-dom";
import App from "./components/app-wrapper/app-wrapper.component"; // Root component
import LoanInfo from "./components/loan-info/loan-info.component";
import LoanPayment from "./components/loan-payment/loan-payment.component";
import LoanReview from "./components/loan-review/loan-review.component";
import ProcessComplete from "./components/process-complete/process-complete.component";
import PaymentUnavailable from "./components/payment-unavailable/payment-unavailable.component";
import SkipAPayUnavailable from "./components/skip-a-pay-unavailable/skip-a-pay-unavailable.component";
import { Provider } from "react-redux";
import store from "./store";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import "bootstrap/dist/css/bootstrap.css"; // Bootstrap
import "./index.css";
import "babel-polyfill";
import ConfirmationPage from "./components/confirmation-page/component";
import HomeEquityAppraisal from "./pages/home-equity-appraisal/component";
import LinkIsNoLongerValid from "./pages/home-equity-appraisal/link-is-no-longer-valid.component";
import AuthPaymentParent from "./components/authenticated-payments/parent/auth-payment-parent.component";
import AuthPaymentIntake from "./components/authenticated-payments/intake/auth-payment-intake.component";
import CardControlsParent from "./components/card-controls/parent/card-controls-parent.component";
import CardControlsIntake from "./components/card-controls/intake/card-controls-intake.component";
import CardControlsIneligibilityPage from "./components/card-controls/ineligibility-page/card-controls-ineligibility-page.component";
import ReactGA from "react-ga";

const history = createHistory();

ReactGA.initialize("UA-18284649-1");
ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App>
        <Switch>
          <Route exact path="/" component={LoanInfo} />
          <Route path="/loan-info" component={LoanInfo} />
          <Route path="/loan-payment" component={LoanPayment} />
          <Route path="/loan-review" component={LoanReview} />
          <Route path="/complete" component={ProcessComplete} />
          <Route path="/payment-unavailable" component={PaymentUnavailable} />
          <Route path="/skip-a-pay" component={LinkIsNoLongerValid} />
          <Route path="/confirmation/:requestType" component={ConfirmationPage} />
          <Route path="/skip-a-pay-unavailable" component={SkipAPayUnavailable} />
          <Route path="/appraisal-charge/:guid" component={HomeEquityAppraisal} />
          <Route path="/link-is-no-longer-valid" component={LinkIsNoLongerValid} />
          <Route path="/authenticated-payments/:guid" component={AuthPaymentIntake} />
          <Route path="/authenticated-payments" component={AuthPaymentParent} />
          <Route path="/card-controls/:guid" component={CardControlsIntake} />
          <Route path="/card-controls" component={CardControlsParent} />
          <Route path="/card-controls-ineligibility" component={CardControlsIneligibilityPage} />
          <Route
            path="*"
            render={() => {
              window.location.href = "/";
              return null;
            }}
            key="nomatch"
          />
        </Switch>
      </App>
    </Router>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js